"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBrush = exports.useClickOutside = exports.useSetRefs = exports.composeOptions = void 0;

var _react = _interopRequireWildcard(require("react"));

var d3brush = _interopRequireWildcard(require("d3-brush"));

var d3selection = _interopRequireWildcard(require("d3-selection"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var composeOptions = function composeOptions(_ref) {
  var options = _extends({}, _ref);

  return Object.keys(options).reduce(function (a, c) {
    if (options[c]) {
      a.push(c.split("").map(function (c, i) {
        return i === 0 ? c.toUpperCase() : c;
      }).join(""));
    }

    return a;
  }, []).join("");
};

exports.composeOptions = composeOptions;

var useSetRefs = function useSetRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return _react["default"].useCallback(function (node) {
    [].concat(refs).forEach(function (ref) {
      if (!ref) return;

      if (typeof ref === "function") {
        ref(node);
      } else {
        ref.current = node;
      }
    });
  }, [refs]);
}; // // WARNING: this hook will only work if the setNode is set to a DOM element, e.g. div, input, etc., not a React element!!!
// To use this with a React Element, you must use Ref Forwarding: https://reactjs.org/docs/forwarding-refs.html


exports.useSetRefs = useSetRefs;

var useClickOutside = function useClickOutside(handleClick) {
  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      node = _useState2[0],
      setNode = _useState2[1];

  (0, _react.useEffect)(function () {
    var checkOutside = function checkOutside(e) {
      if (node.contains(e.target)) {
        return;
      }

      typeof handleClick === "function" && handleClick(e);
    };

    node && document.addEventListener("mousedown", checkOutside);
    return function () {
      return document.removeEventListener("mousedown", checkOutside);
    };
  }, [node, handleClick]);
  return [setNode, node];
};

exports.useClickOutside = useClickOutside;

var d3 = _objectSpread(_objectSpread({}, d3brush), d3selection);

var getInitialBrushState = function getInitialBrushState(type) {
  return {
    group: null,
    brush: d3[type](),
    Brush: function Brush() {
      return null;
    },
    width: 0,
    height: 0,
    selection: null
  };
};

var reducer = function reducer(state, action) {
  return _objectSpread(_objectSpread({}, state), action);
};

var useBrush = function useBrush(node) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "brush";

  var _useReducer = (0, _react.useReducer)(reducer, type, getInitialBrushState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      _useReducer2$ = _useReducer2[0],
      group = _useReducer2$.group,
      brush = _useReducer2$.brush,
      Brush = _useReducer2$.Brush,
      width = _useReducer2$.width,
      height = _useReducer2$.height,
      selection = _useReducer2$.selection,
      dispatch = _useReducer2[1];

  (0, _react.useEffect)(function () {
    var setGroup = function setGroup(n) {
      return dispatch({
        group: n
      });
    };

    dispatch({
      Brush: /*#__PURE__*/_react["default"].memo(function () {
        return /*#__PURE__*/_react["default"].createElement("g", {
          ref: setGroup
        });
      })
    });
  }, []);
  (0, _react.useEffect)(function () {
    if (node && group) {
      var brushEnd = function brushEnd(e) {
        return dispatch({
          selection: group ? d3.brushSelection(group) : null
        });
      };

      d3.select(group).call(brush.on("end", brushEnd, 50));
    } else if (width && height) {
      dispatch({
        selection: null
      });
      dispatch({
        width: 0,
        height: 0
      });
    }

    return function () {
      return brush.on("end", null);
    };
  }, [node, group, brush, width, height]);

  if (node) {
    var rect = node.getBoundingClientRect();

    if (rect.width !== width || rect.height !== height) {
      dispatch({
        width: rect.width,
        height: rect.height
      });
      brush.extent([[0, 0], [rect.width, rect.height]]);
    }
  }

  (0, _react.useEffect)(function () {
    if (node) {
      var _rect = node.getBoundingClientRect();

      if (_rect.width !== width || _rect.height !== height) {
        dispatch({
          width: _rect.width,
          height: _rect.height
        });
        brush.extent([[0, 0], [_rect.width, _rect.height]]);
      }
    }
  }, [node, brush, width, height]);
  return {
    Brush: Brush,
    selection: selection,
    clearBrush: function clearBrush() {
      return brush.clear(d3.select(group));
    }
  };
};

exports.useBrush = useBrush;